import Entities from "./shared/Entities";
import { createState } from "./shared/BasicState";

export default class ToggleOutside {
  constructor() {
    this.entities = new Entities("ToggleOutside", "[data-toggle-outside]", ToggleOutside.initSingle, ToggleOutside.destroySingle);
  }

  static initSingle(containerEl) {
    const id = containerEl.getAttribute("data-toggle-outside");
    const stateId = containerEl.getAttribute("data-toggle-outside-state") ?? id;
    const hideKey = containerEl.getAttribute("data-toggle-outside-key") ?? null;

    const modal = document.querySelectorAll("[data-toggle-outside]");

    modal.forEach((el) => {
      el.addEventListener(
        "wheel",
        (e) => {
          e.stopPropagation();
        },
        { passive: true },
      );
    });

    const state = createState(stateId);

    // methods
    function onClickOutside(e) {
      if (e.target.closest(`[data-toggle-close="${id}"]`) !== null) {
        state.set(hideKey);
        return;
      }

      if (e.target.closest(`[data-toggle-outside="${id}"]`) !== null || e.target.closest(`[data-toggle-button="${id}"]`) !== null) return;

      state.set(hideKey);
    }

    // state
    function onStateChange(nextKey) {
      if (nextKey !== hideKey) {
        document.addEventListener("click", onClickOutside);
      } else {
        document.removeEventListener("click", onClickOutside);
      }
    }
    state.subscribe(onStateChange);

    function destroy() {
      document.removeEventListener("click", onClickOutside);
      state.unsubscribe(onStateChange);
    }

    return {
      destroy,
    };
  }

  static destroySingle({ entityObj }) {
    entityObj?.destroy();
  }
}
